import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrPledgePageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_pledge'
        title='Pledge terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'guarantee', subNavType: 'guarantee', subNavPage: 'pledge' }}
      />
    )
  }
}

export default MasterLoanAgrPledgePageSF
